import Cookies from 'js-cookie';

function BuyNewController($scope, $route, $location, TicketsSvc, TicketHandlerSvc) {
  'ngInject';

  $scope.navDisabled = " disabled"
  $scope.selectedTicketsHtml = ""
  $scope.TicketCount = 0;

  jQuery(document).ready(function ($) {
    if (Cookies.get('TLF_Auth_Token') !== undefined) {
      TicketsSvc.get({ APIKey: Cookies.get('TLF_Auth_Token') }, function (data) {
        $scope.Tickets = data;
      });
    } else {
      var date = new Date();
      var minutes = 60000;
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      Cookies.set('TLF_LastPage', $location.$$path, { expires: date });
      $location.path('/connect').replace();
      $route.reload();
    }
  });

  $scope.UpdateTickets = function (index) {

    var noTickets = true
    var foundCount = 0

    if ($scope.Tickets[index].Selected == true) {
      $scope.Tickets[index].Selected = false
    } else {
      $scope.Tickets[index].Selected = true
    }

    $scope.Tickets.forEach(function (i, index) {
      if (i.Selected == true) {
        foundCount ++
        noTickets = false
        $scope.navDisabled = ""
      }
    });
    if (noTickets == true) {
      $scope.navDisabled = " disabled"
    }
    if (foundCount == 1) {
      $scope.TicketCount = foundCount;
    } else {
      $scope.TicketCount = foundCount
      $scope.selectedTicketsHtml = foundCount
    }
  }
  $scope.CheckOut = function () {
    var selectedTickets = []
    $scope.Tickets.forEach(function (i, index) {
      if (i.Selected == true) {
        selectedTickets.push({ Id: i.Id, TicketNumber: i.TicketNumber, DrawsRemaining: i.DrawsRemaining })
      }
    });
    TicketHandlerSvc.setTickets(selectedTickets)
  }
};

export default {
  name: 'buynewController',
  fn: BuyNewController
}